<template>
  <div class="popup-wrp" @click="$emit('cancelR')">
    <div class="popup-mask">
      <div class="popup-content" @click.stop>
        <p class="popup-title">是否确认要举报呢？</p>
        <p class="popup-desc">
          有时能包容不同的观点和真实的反馈，<br />也是一种智慧
        </p>
        <ul class="report-list">
          <li
            :class="['report-item', item.key == eportReason ? 'active' : '']"
            v-for="item in reportList"
            :key="item.key"
            @click="selectItem(item)"
          >
            <p>{{ item.content }}</p>
          </li>
        </ul>
        <div class="popup-btn-list">
          <p class="confirm-btn" @click="$emit('confirm', eportReason)">确认</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportConfig } from 'api/platform/topicDetail'
export default {
  components: {},
  mounted() {
    this.getReportList()
  },
  data() {
    return {
      eportReason: '',
      reportList: []
    }
  },
  methods: {
    selectItem(item) {
      this.eportReason = item.key
    },
    async getReportList() {
      await reportConfig().then(res => {
        if (res.code == 0) {
          this.reportList = res.data.config
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-wrp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  .popup-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-content {
    width: pxToRem(600);
    box-sizing: border-box;
    padding: pxToRem(50) pxToRem(30);
    background: #ffffff;
    border-radius: pxToRem(30);
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url('~images/platform/report_entry_bg_h5.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    .close-btn {
      width: pxToRem(48);
      height: pxToRem(48);
      object-fit: cover;
      position: absolute;
      top: pxToRem(20);
      right: pxToRem(20);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .popup-title {
      margin-bottom: pxToRem(22);
      text-align: center;
      font-size: pxToRem(36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #21252d;
      line-height: pxToRem(36);
    }
    .popup-desc {
      margin-bottom: pxToRem(40);
      text-align: center;
      font-size: pxToRem(24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bcc2cf;
      line-height: pxToRem(40);
    }
    $total_height: pxToRem(50);
    $margin_bottom: pxToRem(30);
    ul.report-list {
      font-size: 0;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: $total_height - $margin_bottom;
      box-sizing: border-box;
      li {
        width: pxToRem(256);
        height: pxToRem(68);
        background-color: #f3f4f5;
        border-radius: pxToRem(34);
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        margin-bottom: $margin_bottom;
        font-size: pxToRem(26);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6c798c;
        line-height: pxToRem(37);
        padding: 0 10px;
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &.active {
          background-color: #e8ecff;
          color: #6982fa;
        }
      }
    }
    .popup-btn-list {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: pxToRem(28);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 1px solid transparent;
        color: #ffffff;
        width: pxToRem(380);
        height: pxToRem(80);
        background: #6982fa;
        border-radius: pxToRem(50);
      }
    }
  }
}
</style>
